import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log("regions controller connect!!", this.element);

    this.checkCountry(true);
  }

  checkCountry(defa) {
    console.log("REGIONS!");
    if (
      $("#country-input").val() == "US" ||
      ($("#country-input").val() == "" && defa)
    ) {
      $("#region-input").val("");
      $("#region-input").prop("disabled", true);
      $("#region").hide();
      $("#state").show();
      $("#state-input").prop("disabled", false);
    } else {
      $("#state-input").val("");
      $("#state-input").prop("disabled", true);
      $("#state").hide();
      $("#region").show();
      $("#region-input").prop("disabled", false);
    }
  }
}
